import "./../../App.css";
import SoftwareDev from "./SoftwareDev";

function Home() {
	return (
		<>
			<div className="items-center pt-10 pb-20 ">
				<SoftwareDev />
			</div>
		</>
	);
}

export default Home;
